import type { RootState } from '~features';

const selectTokenGatePolicy = (state: RootState) => state.tokenGatePolicyConfig;

const selectTokenGatePolicyTraits = (state: RootState) => state.tokenGatePolicyConfig.traits;

export { selectTokenGatePolicy, selectTokenGatePolicyTraits };
